/**
 * Can also be targeted using keywords, eg:
 * - [to, only, down]: mdToXl, lgOnly, smDown
 * - hideFrom, hideBelow
 *
 * > When applying breakpoints to component variants, we recommend using
 * > explicit breakpoints instead of using the base breakpoint:
 *
 * @example
 * ```tsx
 * // okay, but can lead to style leaking ⚠️
 * <Button variant={{ base: "solid", md: "outline" }}>Button</Button>
 *
 * // good ✅
 * <Button variant={{ smDown: "solid", md: "outline" }}>Button</Button>
 * ```
 *
 * @see https://chakra-ui.com/docs/styling/responsive-design
 */
export const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
};

export type Breakpoint = 'base' | keyof typeof breakpoints;

/**
 * BR addition: these breakpoints are considered 'mobile',
 * in that they hide the desktop navigation and display mobile nav
 */
export const mobileBreakpoints: Breakpoint[] = ['base', 'sm', 'md'] as const;
